/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import React, { useState } from "react";
import moment from "moment/moment";
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import { DeleteOutlineOutlined } from "@mui/icons-material";
import { deleteTransaction } from "Redux/actions/transaction";
import { useDispatch } from "react-redux";
import AlertDialog from "layouts/tables/dialog";
import { getAllTransaction } from "Redux/actions/transaction";


export default function TransactionTable ({transactions,formdata,setFormData,setOpen,edit,setEdit}) {
    const dispatch=useDispatch();
    const [confirm,setConfirm]=useState(false);
    const [id,setId]=useState("");
    const isValidDate = (dateString) => {
       //check for valid date format
       return !Number.isNaN(new Date(dateString).getTime());
    }
       
    const handleConfirm=(id)=>{
        setConfirm(true);
        setId(id);
    }
    const handleAction=(transaction)=>{
        setFormData({...formdata,id:transaction._id,name:transaction.name,amount:transaction.amount,type:transaction.type,date:isValidDate(transaction.date)?new Date(transaction.date):new Date()});
        setOpen(true);
       setEdit(true);
        
    }
    const handleDelete=async()=>{
        await dispatch(deleteTransaction(id));
        await dispatch(getAllTransaction());
        setConfirm(false);
    }
  return (
    <div className="table">
      <table>
  <tr style={{position:"sticky"}}>
    <th>#</th>
    <th>Name</th>
    <th>Amount</th>
    <th>Date</th>
    <th>Action</th>
  </tr>
  {transactions?.map((transaction,index)=>(
    <tr key={index}>
    <td>{index+1}</td>
    <td>{transaction.name}</td>
    <td>{transaction.amount}</td>
    <td>{moment(transaction?.date).format('DD MMM YY')}</td>
    <td>
        <button onClick={()=>handleAction(transaction)} className="edit-button"><ModeEditOutlinedIcon/></button>
        <button onClick={()=>handleConfirm(transaction._id)} style={{marginLeft:"20px"}} className="edit-button"><DeleteOutlineOutlined/></button>
        <AlertDialog open={confirm} setOpen={setConfirm} handleDelete={handleDelete}/>
        
    </td>
  </tr>
  ))}

</table>
    </div>
  )
}